import {createAsyncThunk} from '@reduxjs/toolkit';
import {itemsApi} from 'api';
import {IQuestionBase, IUpdateItemPayload} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {itemsMessages} from '../../utils';
import {prefix} from './config';

export const createUpdateItemThunk: any = createAsyncThunk<IQuestionBase, IUpdateItemPayload>(
  `${prefix} createUpdateItem`,
  async (payload: IUpdateItemPayload, {dispatch, rejectWithValue}) => {
    try {
      const {parsedBody} = await itemsApi.createUpdateItem(payload);
      dispatch(toastNotificationManager.createSuccessToastAction(itemsMessages.updateSuccess));
      return parsedBody;
    } catch (err) {
      dispatch(toastNotificationManager.createErrorToastAction(err.parsedBody));
      return rejectWithValue({error: err});
    }
  }
);
